import React from "react";
import DATA from "../data/data.json";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Serviços Hidrólogicos e de Geoprocessamento</h2>
        </div>
        <div className="row features-mobile">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-xs-6 col-md-6 features2"
                >
                  {" "}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
      <div className="text-center container rounded" id="services">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Projetos de Compensação e Reposição Florestal</h2>
        </div>
        <div className="row row-projects features-mobile">
          {DATA.Features2
            ? DATA.Features2.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-xs-6 col-md-6 features2 card card-height"
                >
                  {" "}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
        {/* <div className="row">
          {DATA.Features3
            ? DATA.Features3.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-xs-12 col-md-12 features3  card card-height"
                >
                  {" "}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div> */}
      </div>
    </div>
  );
};
